import "./VideoRecordingPreview.css"
import React, { useEffect, useMemo } from "react";
import VideocamIcon from '@mui/icons-material/Videocam';
import { IRecordingInfo } from "../RecordingDialog";

interface IVideoRecordingPreviewProps {
    isRecording: boolean;
    videoRecording: IRecordingInfo | undefined;
    videoLiveRef: React.RefObject<HTMLVideoElement>;
}

function VideoRecordingPreview({videoRecording, isRecording, videoLiveRef}: IVideoRecordingPreviewProps) {

    const videoRecordingUrl = useMemo(() => videoRecording ? URL.createObjectURL(videoRecording?.recording) : undefined, [videoRecording]);

    useEffect(() => {
        return () => {
            if (videoRecordingUrl) {
                URL.revokeObjectURL(videoRecordingUrl);
            }
        };
    }, [videoRecordingUrl]);

    return (
        <div className="video-recording__container">
            {(!isRecording && !videoRecording) &&
            (
                <div className="video-recording__placeholder">
                    <VideocamIcon className="video-recording__placeholder-icon"/>
                </div>
            )}
            {
                isRecording ? (  
                    <video className="video-recording-preview" autoPlay muted
                        ref={videoLiveRef} id="video-recording"></video>
                ) : videoRecording && (        
                    <video className="video-recording" controls src={videoRecordingUrl}
                        id="video-recording"></video>
                )
            }
        </div>
    );
}

export default VideoRecordingPreview;
